import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "mfdx_gate";

export default function SiteGate({ children }) {
  const [state, setState] = useState(sessionStorage.getItem(KEY) === "ok" ? "open" : "checking");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (state !== "checking") return;
    fetch(`${API}/gate/status`)
      .then((r) => r.json())
      .then((d) => {
        if (!d.enabled) { sessionStorage.setItem(KEY, "ok"); setState("open"); }
        else setState("locked");
      })
      .catch(() => setState("locked"));
  }, [state]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const res = await fetch(`${API}/gate/verify`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      if (res.ok) { sessionStorage.setItem(KEY, "ok"); setState("open"); }
      else setErr("Incorrect password. Please try again.");
    } catch { setErr("Something went wrong. Please try again."); }
    finally { setBusy(false); }
  };

  if (state === "open") return children;
  if (state === "checking") return <div className="min-h-screen grid place-items-center bg-[#0A0A0A] text-gray-500 font-head">Loading…</div>;

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] px-4 relative overflow-hidden" data-testid="site-gate">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full grad-amber opacity-25 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full grad-violet-coral opacity-20 blur-3xl" />
      <form onSubmit={submit} className="relative w-full max-w-sm bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur-xl text-center">
        <div className="w-14 h-14 rounded-2xl grad-amber grid place-items-center text-black font-head font-bold text-xl mx-auto mb-4 amber-glow">M</div>
        <h1 className="font-head font-bold text-2xl text-white">MFDX</h1>
        <p className="text-gray-400 text-sm mt-1 mb-6">This site is private. Enter the access password to continue.</p>
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoFocus placeholder="Access password"
          data-testid="site-gate-input"
          className="w-full rounded-xl bg-white/10 border border-white/15 text-white placeholder-gray-500 px-4 py-3 text-sm outline-none focus:border-amber-400" />
        {err && <div className="text-red-400 text-sm mt-3" data-testid="site-gate-error">{err}</div>}
        <button type="submit" disabled={busy} data-testid="site-gate-submit"
          className="w-full mt-4 grad-amber text-black rounded-xl py-3 font-semibold amber-glow hover:brightness-105 transition disabled:opacity-60">
          {busy ? "Checking…" : "Unlock"}
        </button>
      </form>
    </div>
  );
}
